import React, { useState, useRef, useEffect } from "react";
import { country } from "../../constants/country";

function CountryAutocomplete({ value, name, onChange, className, placeholder = "Search country…" }) {
  const [query, setQuery] = useState(value || "");
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  // Sync display text when value changes externally
  useEffect(() => {
    setQuery(value || "");
  }, [value]);

  const filtered = query.trim()
    ? country.filter((c) =>
        c.name.toLowerCase().includes(query.toLowerCase())
      )
    : country;

  const handleSelect = (name_) => {
    setQuery(name_);
    setOpen(false);
    onChange({ target: { name, value: name_ } });
  };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    setOpen(true);
    if (!e.target.value) {
      onChange({ target: { name, value: "" } });
    }
  };

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        // If input doesn't match any country, clear it
        const match = country.find(
          (c) => c.name.toLowerCase() === query.toLowerCase()
        );
        if (!match) {
          setQuery(value || "");
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [query, value]);

  return (
    <div className="relative" ref={containerRef}>
      <input
        type="text"
        autoComplete="off"
        value={query}
        placeholder={placeholder}
        className={className}
        onChange={handleInputChange}
        onFocus={() => setOpen(true)}
      />
      {open && filtered.length > 0 && (
        <ul className="absolute z-50 left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg max-h-52 overflow-y-auto">
          {filtered.map((c) => (
            <li
              key={c.code}
              onMouseDown={() => handleSelect(c.name)}
              className={`px-4 py-2.5 text-sm cursor-pointer hover:bg-primary-bg hover:text-primary ${
                c.name === value ? "bg-primary-bg text-primary font-medium" : "text-gray-700"
              }`}
            >
              {c.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CountryAutocomplete;
